module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lgrey",
    attrs: {
      "id": "krossinguprights"
    }
  }, [_c('tooltips', {
    attrs: {
      "tippy": _vm.tooltipsData,
      "box": _vm.tooltipsBox
    }
  }, [_c('room', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "display": "block",
      "bg-line-text": "bg-lgrey"
    }
  }, [_c('krossingrow', {
    style: (_vm.rowTooltips.style),
    attrs: {
      "height": _vm.heights[_vm.rowTooltips.height],
      "is-editing": false,
      "show-add": true,
      "show-edit": true,
      "disable-hover": true,
      "enabled": false
    }
  }, _vm._l((_vm.objects()[0]), function(object, obj_index) {
    return _c('krossingobject', {
      key: obj_index,
      attrs: {
        "width": _vm.rowTooltips.object_width
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('room', {
    attrs: {
      "display": "block",
      "bg-line-text": "bg-lgrey"
    }
  }, _vm._l((_vm.rows), function(row, row_index) {
    return _c('krossingrow', {
      key: row_index,
      style: (row.style),
      attrs: {
        "height": _vm.heights[row.height],
        "is-editing": _vm.currentIndex === row_index,
        "show-add": !_vm.room_is_full && row_index === _vm.rows.length - 1
      },
      on: {
        "add": function($event) {
          _vm.addRow()
        },
        "click": function($event) {
          _vm.editRow(row_index)
        }
      }
    }, _vm._l((_vm.objects()[row_index]), function(object, obj_index) {
      return _c('krossingobject', {
        key: row_index * obj_index,
        attrs: {
          "width": row.object_width
        }
      })
    }))
  })), _vm._v(" "), _c('editbar', {
    attrs: {
      "buttons": _vm.editButtons,
      "is-visible": _vm.editBarIsVisible,
      "show-delete": _vm.rows.length > 1
    },
    on: {
      "delete": function($event) {
        _vm.removeConfirmUpright(_vm.currentIndex)
      },
      "confirm": _vm.hideEditBar
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c816542"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/uprights/Krossing.vue
// module id = 654
// module chunks = 0